import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import '../../css/Login.css'; // Reuse the CSS file for Login

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'pageview',
                page: '/forgot-password'
            });
        }
    }, []);

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        
        try {
            // Use the correct URL structure for production environment
            const baseUrl = process.env.REACT_APP_BASE_URL;
            
            // Try with the /api/ prefix like the register endpoint uses
            const url = `${baseUrl}/api/auth/forgot-password`;
            console.log(`Sending password reset request to: ${url}`);
            
            const response = await axios.post(url, { email });
            setMessage(response.data);
        } catch (error) {
            console.error('Forgot password error:', error);
            
            // Provide more specific error messages based on the error type
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (error.response.status === 404) {
                    setMessage('Password reset service not found. Please contact support.');
                } else if (error.response.status === 400) {
                    setMessage(error.response.data.message || 'Invalid email address');
                } else {
                    setMessage(`Server error: ${error.response.data.message || 'Error sending password reset email'}`);
                }
            } else if (error.request) {
                // The request was made but no response was received
                setMessage('No response from server. Please check your internet connection and try again.');
            } else {
                // Something happened in setting up the request that triggered an Error
                setMessage('Error sending password reset email. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h2 className="login-title">Forgot Password</h2>
                <form onSubmit={handleForgotPassword} className="login-form">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="login-input"
                    />
                    <button 
                        type="submit" 
                        className="login-button" 
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="button-content">
                                <CircularProgress size={20} color="inherit" />
                                <span>Sending...</span>
                            </span>
                        ) : (
                            'Send Reset Link'
                        )}
                    </button>
                </form>
                {message && <p className={`reset-message ${message.includes('Error') || message.includes('failed') ? 'error-message' : 'success-message'}`}>{message}</p>}
            </div>
        </div>
    );
};

export default ForgotPassword;
